import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography, Container, Alert
} from '@mui/material';
import { School, ArrowBack } from '@mui/icons-material';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await fetch('/api/v1/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setMessage('Password reset link has been sent to your email.');
        // Optionally empty the email field
        setEmail('');
      } else {
        setError(data.message || 'Failed to send reset link. Ensure SMTP settings are configured.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a2332 0%, #2c3e50 50%, #1a9e8f 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Card sx={{ borderRadius: '12px', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)', border: 'none' }}>
          <Box sx={{ bgcolor: '#1a9e8f', py: 3, textAlign: 'center' }}>
            <School sx={{ fontSize: 48, color: '#fff', mb: 1 }} />
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>VP School MIS</Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>Forgot Password</Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
            {message && <Alert severity="success" sx={{ mb: 3 }}>{message}</Alert>}

            <Typography variant="body2" sx={{ mb: 3, color: '#555', textAlign: 'center' }}>
              Enter your registered email address and we will send you a link to reset your password.
            </Typography>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth label="Email Address" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                required margin="normal" autoFocus
              />

              <Button
                type="submit" fullWidth variant="contained" disabled={loading}
                sx={{ mt: 3, mb: 2, py: 1.2, bgcolor: '#1a9e8f !important', fontWeight: 700 }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>

            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Button 
                variant="text" 
                startIcon={<ArrowBack />}
                onClick={() => navigate('/login')}
                sx={{ color: '#1a9e8f', textTransform: 'none', fontWeight: 600 }}
              >
                Back to Login
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
